exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/claim/claim-adjuster-info/claim-adjuster-info.component.scss
// module id = ../../../../../src/app/claim/claim-adjuster-info/claim-adjuster-info.component.scss
// module chunks = main